<template>
    <section class="min-h-screen flex sm:items-center items-start fixed top-0 min-w-full z-50 bg-gray-100 dark:!bg-base-100">
        <div class="container m-auto">
            <div class="flex justify-center relative">
                <div class="sm:scale-100 transform scale-150 -translate-x-6">
                    <Unauathorized />
                </div>
                <div class="absolute text-center md:bottom-16 -bottom-28">
                    <div class="mb-5">
                        <h2 class="text-black dark:text-white text-shadow-blueShadow sm:text-100 text-33 font-medium sm:mb-3 mb-1">{{ __('Access error!') }}</h2>
                        <p class="sm:text-22 text-sm text-gray-880 font-medium mt-2">{{ __('You are not allowed to access this page.') }}</p>
                    </div>
                    <div class="">
                        <router-link :to="{name:'user.home'}" class="text-blue-700 font-bold sm:text-lg text-xs">{{ __('Return to the site') }}
                            <svg class="inline text-lg md:w-7 md:h-7 w-4 h-4" viewBox="0 0 28 29" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path opacity="0.4"
                                    d="M17.9752 13.1044L22.1843 12.7322C23.1289 12.7322 23.8948 13.5055 23.8948 14.4593C23.8948 15.4131 23.1289 16.1864 22.1843 16.1864L17.9752 15.8142C17.2341 15.8142 16.6333 15.2076 16.6333 14.4593C16.6333 13.7098 17.2341 13.1044 17.9752 13.1044"
                                    fill="#3B82F6"></path>
                                <path
                                    d="M3.84057 13.173C3.90636 13.1065 4.15213 12.8258 4.383 12.5927C5.72978 11.1325 9.2463 8.74482 11.0859 8.01411C11.3652 7.89755 12.0714 7.64938 12.45 7.63184C12.8112 7.63184 13.1563 7.71581 13.4852 7.88126C13.8961 8.11313 14.2238 8.47911 14.405 8.91027C14.5205 9.20857 14.7017 10.1047 14.7017 10.121C14.8817 11.0999 14.9797 12.6917 14.9797 14.4514C14.9797 16.1259 14.8817 17.6525 14.734 18.6477C14.7178 18.6652 14.5366 19.7769 14.3392 20.158C13.978 20.8548 13.2717 21.286 12.5158 21.286H12.45C11.9572 21.2697 10.922 20.8373 10.922 20.8222C9.18052 20.0915 5.74716 17.8192 4.36687 16.3089C4.36687 16.3089 3.97711 15.9203 3.8083 15.6784C3.54515 15.33 3.41357 14.8988 3.41357 14.4677C3.41357 13.9864 3.56128 13.5389 3.84057 13.173"
                                    fill="#3B82F6"></path>
                            </svg>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script setup>
import Unauathorized from '../svg/403.vue';
</script>